module.exports = __webpack_public_path__ + "static/media/1.5a544715.JPG";